import { DotsLoading } from 'lib/DotsLoading/DotsLoading';
import SVG from 'react-inlinesvg';

type MetricsWidgetProps = {
  name: string;
  value: string;
  icon: string;
  isLoaderVisible: boolean;
};

const MetricsWidget: React.FC<MetricsWidgetProps> = ({ name, value, icon, isLoaderVisible }) => {
  return (
    <div className="bg-neutral-50 group-hover:bg-primary-50 rounded-lg border border-neutral-300 group-hover:border-primary-600-opacity-60 h-20 w-full px-4 py-3 flex">
      <SVG src={icon} className="mt-0.5 mr-2" />
      <div className="flex flex-1 flex-col">
        <p className="body-sm text-neutral-900 mb-0.5">{name}</p>
        {isLoaderVisible ? (
          <div className="h-8 flex flex-1 items-center">
            <DotsLoading />
          </div>
        ) : (
          <p className="header-2xl text-neutral-900">{value}</p>
        )}
      </div>
    </div>
  );
};

export default MetricsWidget;
